var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconEditTableBottom = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-2.161 -5.661)" },
                React.createElement("path", { d: "M10.3,31.1c-3.8-3.8-3.8-10,0-13.8s10-3.8,13.8,0c3.8,3.8,3.8,10,0,13.8" })),
            React.createElement("path", { strokeLinecap: "square", d: "M14.8,8.5V0" }),
            React.createElement("g", { transform: "translate(15.738 11.576)" },
                React.createElement("path", { d: "M-4.6,6.9C-4.6,4.8-2.8,3-0.7,3s3.9,1.7,3.9,3.9c0,2.1-1.7,3.9-3.9,3.9l0,0\n\t\t\tC-2.8,10.8-4.6,9.1-4.6,6.9z" })))));
});
export default IconEditTableBottom;
//# sourceMappingURL=IconEditTableBottom.js.map